/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Resources_Download_Linux_Step3Inputs */

const en_gc_resources_download_linux_step3 = /** @type {(inputs: Gc_Resources_Download_Linux_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Double-click the AppImage, or run ./gridcraft-0.7.0-linux-x86_64.AppImage from that folder.`)
};

const zh_gc_resources_download_linux_step3 = /** @type {(inputs: Gc_Resources_Download_Linux_Step3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`双击 AppImage，或在所在文件夹运行 ./gridcraft-0.7.0-linux-x86_64.AppImage。`)
};

/**
* | output |
* | --- |
* | "Double-click the AppImage, or run ./gridcraft-0.7.0-linux-x86_64.AppImage from that folder." |
*
* @param {Gc_Resources_Download_Linux_Step3Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_resources_download_linux_step3 = /** @type {((inputs?: Gc_Resources_Download_Linux_Step3Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Resources_Download_Linux_Step3Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_resources_download_linux_step3(inputs)
	return zh_gc_resources_download_linux_step3(inputs)
});
export { gc_resources_download_linux_step3 as "gc.resources.download.linux.step3" }